import type {
  ExperimentVariable,
  FeatureVariable,
  UrgencyEntries,
} from '../../types'
import { useUrgency } from './useUrgency'

export type InnerUrgencyProps = {
  config: UrgencyEntries
  variables?: ExperimentVariable
  children: (props: FeatureVariable) => JSX.Element
}

export const InnerUrgency = ({
  children,
  config,
  variables,
}: InnerUrgencyProps) => {
  const urgencies = useUrgency({ entries: config, variables })

  return children(urgencies)
}
